module.exports = __webpack_public_path__ + "images/document_icons/wav.png";